module.exports = __webpack_public_path__ + "img/1544.87557fd5.gif";